<template>
  <v-data-table
    v-bind="dataTableAttrs"
    :headers="headersShown"
    :items="list"
    :loading="isLoading"
    :options.sync="options"
    :server-items-length="total"
    :items-per-page.sync="itemsPerPage"
    v-model="selectedItems"
    @update:items-per-page="handleItemsPerPageUpdated"
    :show-select="false"
  >
    <template v-slot:top>
      <rs-table-title-bar
        class="mt-6"
        v-if="$refs.headSearch"
        title=""
        icon=""
        @clear-filters="$refs.headSearch.reset"
        @reload="loadList"
        :search.sync="search.query"
        hide-edit
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:body.prepend="{ headers }">
      <rs-table-head-search
        :headers="headers"
        :search.sync="search"
        ref="headSearch"
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:body.append="{ headers }">
      <rs-table-foot-totals :headers="headers" :totals="footTotals" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.edit="{ item }">
      <router-link
        :to="{
          name: 'definitions.residents.edit',
          params: {
            id: item.id,
          },
        }"
      >
        <i class="menu-icon mdi mdi-pencil"></i>
      </router-link>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.cluster_name="{ item }">
      <router-link
        :to="{
          name: 'definitions.clusters.edit',
          params: {
            id: item.cluster_id,
          },
        }"
      >
        {{ item.cluster_name }}
      </router-link>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.name="{ item }">
      <router-link
        :to="{
          name: 'definitions.residents.show',
          params: {
            id: item.id,
          },
        }"
      >
        {{ item.name }}
      </router-link>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.email="{ value }">
      <rs-table-cell-email :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.phone="{ value }">
      <rs-table-cell-phone :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.house_user_count="{ item, value }">
      <router-link
        :to="{
          name: 'definitions.residents.edit',
          params: {
            id: item.id,
          },
          hash: '#houses',
        }"
      >
        <rs-table-cell-number :value="value" />
      </router-link>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.balance="{ value }">
      <rs-table-cell-balance colored :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.is_active="{ value }">
      <rs-table-cell-boolean :value="value" />
    </template>
  </v-data-table>
</template>

<script>
import { debounce } from "@/core/plugins/debounce";
import { hasDataTable } from "@/view/mixins";

export default {
  name: "AdminResidentList",
  mixins: [hasDataTable],
  props: {
    userId: {
      type: Number,
      required: false,
    },
  },
  watch: {
    userId() {
      this.loadList();
    },
    search: {
      handler: debounce(function () {
        this.loadList();
      }),
      deep: true,
    },
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    },
  },
  data() {
    return {
      options: {
        sortBy: ["name"],
        sortDesc: [false],
      },
      headers: [
        {
          text: "",
          value: "edit",
          searchable: false,
          sortable: false,
          width: "30px",
          align: "center",
        },
        {
          text: "TYA",
          value: "cluster_name",
          searchable: "text",
        },
        {
          text: "İsim",
          value: "name",
          searchable: "text",
        },
        {
          text: "Bakiye",
          value: "balance",
          searchable: "number",
          align: "end",
        },
        {
          text: "BB İlişki Adet",
          value: "house_user_count",
          searchable: "number",
          notPrice: true,
          align: "end",
        },
        {
          text: "Durum",
          value: "is_active",
          searchable: "isActive",
          align: "center",
        },
        {
          text: "Telefon",
          value: "phone",
          searchable: "text",
        },
        {
          text: "E-posta",
          value: "email",
          searchable: "text",
        },
      ],
    };
  },
  methods: {
    loadList() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.list = [];

      const params = Object.assign(
        this.buildSearchParams(this.search, this.options)
      );

      if (this.userId) {
        params.user_id = this.userId;
      }

      return this.$api
        .query("api-super-admin/residents", {
          params,
        })
        .then((response) => {
          this.loadListFromResponse(response);
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadList();
    });
  },
};
</script>
